import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { bindAll } from '@bibliocommons/utils-react';
import { PrimaryButton } from '@bibliocommons/deprecated-base-buttons';
import { openPopUpWindow } from '@bibliocommons/utils-browser';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import { CHAT_WIDGET_ID } from 'app/constants/LibraryConstants';

export default class ChatWidgetButton extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleClick() {
    const { widget } = this.props;
    const widgetSrc = `/widgets/chat_widget/${widget}`;

    openPopUpWindow({ url: widgetSrc, width: 300, height: 350 });
  }

  render() {
    const { widget } = this.props;

    return (
      <PrimaryButton className={`cp-chat-widget-button ${widget}`} handleClick={this.handleClick}>
        <span aria-hidden>
          <FormattedMessage id="chat_widget_button_text" />
        </span>
        <ScreenReaderMessage>
          <FormattedMessage
            id="ada_link_opens_new_window"
            values={{
              linkText: <FormattedMessage id="chat_widget_button_text" />
            }}
          />
        </ScreenReaderMessage>
      </PrimaryButton>
    );
  }
}

ChatWidgetButton.propTypes = {
  widget: PropTypes.oneOf(Object.values(CHAT_WIDGET_ID)).isRequired
};
